// extracted by mini-css-extract-plugin
export default {"container":"Q00AY9","position":"Zleldg","arrow":"IEV8qS","page":"r1vD9L","withPosition":"MdMxZP","active":"FGoscc","disabled":"XPZZnN"};